export default __webpack_public_path__ + "resources/icons/n341-8816.png";